import { Routes } from '@angular/router';
import { PaymentCenterComponent } from './components/pages/payment-center/payment-center.component';
import { PaymentPortalComponent } from './components/pages/payment-portal/payment-portal.component';
import { MakePaymentComponent } from './components/pages/make-payment/make-payment.component';
import { PaymentSummaryComponent } from './components/pages/payment-summary/payment-summary.component';
import { ErrorSystemFailureComponent } from './components/shared/error-system-failure/error-system-failure.component';

export const routes: Routes = [ 
  {
    path: '',
    redirectTo: 'paymentportal',
    pathMatch: 'full'
  },
  {
    path: 'paymentportal',
    component: PaymentPortalComponent,
    data: { backNav: 'noBack' }
  },
  {
    path: 'payment-center',
    component: PaymentCenterComponent,
    data: { backNav: 'prevPage' }
  },
  {
    path: 'make-payment',
    component: MakePaymentComponent,
    data: { backNav: 'prevPage' }
  },
  {
    path: 'payment-summary',
    component: PaymentSummaryComponent,
    data: { backNav: 'noBack' }
  },
  {
    path: 'error-system-failure',
    component: ErrorSystemFailureComponent,
    data: { backNav: 'allowBack' },
  },
];